import { render } from "./IconSearchFilter.vue?vue&type=template&id=68bd39ba"
import script from "./IconSearchFilter.vue?vue&type=script&lang=js"
export * from "./IconSearchFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__